import { combineReducers } from "redux";

import { authentication } from "./authentication.reducer";
import { alert } from "./alert.reducer";
import { sensor } from "./sensor.reducer";
import { sensorList } from "./sensorlist.reducer";
import { sidebar } from "./sidebar.reducer";
import { sensordata } from "./sensordata.reducer";
import { note } from "./note.reducer";
import { disciplinesList } from "./disciplines.reducer";
import { notesList } from "./notelist.reducer";
import { configuration } from "./configuration.reducer";
import { filteredSensorData } from "./filteredSensorData.reducer";
import { map } from "./map.reducer";
import { header } from "./header.reducer";
import { telemetryAlertData } from "./alerting.reducer";
import { report } from "./report.reducer";
import { selectedAlerts } from "./selectedAlerts.reducer";
import { selectedNotes } from "./selectedNotes.reducer";

const appReducer = combineReducers({
  authentication,
  alert,
  selectedAlerts,
  selectedNotes,
  sensor,
  sensorList,
  sidebar,
  sensordata,
  disciplinesList,
  note,
  notesList,
  configuration,
  filteredSensorData,
  map,
  header,
  telemetryAlertData,
  report
});

const rootReducer = (state, action) => {
  if (action.type === "USERS_LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/index.js